// extracted by mini-css-extract-plugin
export var active = "DropdownGallery-module--active--cd164";
export var box = "DropdownGallery-module--box--30553";
export var container = "DropdownGallery-module--container--e6ae3";
export var imageContent = "DropdownGallery-module--imageContent--33e00";
export var imageMobile = "DropdownGallery-module--imageMobile--c81b5";
export var item = "DropdownGallery-module--item--ce929";
export var listContent = "DropdownGallery-module--listContent--71336";